<template>
  <div class="card-body p-1"><i class="far fa-grin-stars fa-spin"></i></div>
</template>

<script>
export default {
  name: "ContentStaticProviderWait",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
